module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row lobby-article"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.article.loading),
      expression: "!article.loading"
    }],
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "article-body"
  }, [_c('div', {
    staticClass: "col-xs-12 mb15"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$router.push('/cgd/by/article/edit/' + _vm.article.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v("\n\t\t\t\t\t\t编辑\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "text-right mt15"
  }, [_c('span', {
    staticClass: "mr10"
  }, [_vm._v("\n\t\t\t\t\t\t标题：" + _vm._s(_vm.article.title) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "mr10"
  }, [_vm._v("\n\t\t\t\t\t\t点击: " + _vm._s(_vm.article.hit) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "mr10"
  }, [_vm._v("\n\t\t\t\t\t\t作者: " + _vm._s(_vm.article.author) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "mr10"
  }, [_vm._v("\n\t\t\t\t\t\t发布于: " + _vm._s(_vm._f("simpleDate")(_vm.article.releaseTime)) + "\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.article.content)
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.article.loading),
      expression: "article.loading"
    }],
    staticClass: "col-xs-12 text-center mt40"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-3x fa-fw"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-5af88618"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/article/widget/ArticleView.vue
// module id = 989
// module chunks = 1